import { render, staticRenderFns } from "./FenxiangDetail.vue?vue&type=template&id=790f6350&scoped=true"
import script from "./FenxiangDetail.vue?vue&type=script&lang=js"
export * from "./FenxiangDetail.vue?vue&type=script&lang=js"
import style0 from "./FenxiangDetail.vue?vue&type=style&index=0&id=790f6350&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f6350",
  null
  
)

export default component.exports